package game.controller

import game.Game
import view.Terminal

abstract class Component(var text: String, var col: Int, var row: Int, var width: Int, var height: Int) {
    val left
        get() = col
    val top
        get() = row
    val right
        get() = col + width - 1
    val bottom
        get() = row + height - 1

    var visible = true

    open fun render(game: Game, terminal: Terminal) {}
    open fun down(game: Game) {}
    open fun up(game: Game) {}
    open fun click(game: Game) {}

}